import React from "react";
import { CheckCircle2, Users } from "lucide-react";
import { formatDate } from "../formatTimeAgo";
import { MultiApprovalGroupApprovalHistory } from "./Api/multiapprovalapi";

interface MultiApprovalGroupedHistoryProps {
  groupedApprovals: MultiApprovalGroupApprovalHistory[];
}

export default function MultiApprovalGroupedHistory({
  groupedApprovals,
}: MultiApprovalGroupedHistoryProps) {
  const hasApprovals = groupedApprovals.some((group) => group.approvals.length > 0);
  if (!hasApprovals) {
    return null;
  }

  return (
    <div className="p-3 rounded-lg border border-green-200 dark:border-green-800 bg-green-50 dark:bg-green-950/20">
      <div className="flex items-center gap-2 mb-3">
        <Users className="w-4 h-4 text-green-600 dark:text-green-400" />
        <span className="text-sm font-medium text-green-700 dark:text-green-300">Approvals</span>
      </div>
      <div className="space-y-4">
        {groupedApprovals.map((group) =>
          group.approvals.length > 0 ? (
            <div key={group.groupUuid}>
              <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-green-700 dark:text-green-300">
                {group.groupName}
              </p>
              <ul className="space-y-2">
                {group.approvals.map((approval) => (
                  <li
                    key={`${group.groupUuid}-${approval.approverEmail}-${approval.approvedAt}`}
                    className="flex items-start gap-2 text-sm"
                  >
                    <CheckCircle2 className="w-4 h-4 mt-0.5 shrink-0 text-green-600 dark:text-green-400" />
                    <div className="min-w-0">
                      <p className="font-medium text-green-800 dark:text-green-200">
                        {approval.approverDisplayName || approval.approverEmail}
                      </p>
                      <p className="text-xs text-green-600 dark:text-green-400">
                        {group.groupName}
                        {approval.approvedAt ? ` · ${formatDate(approval.approvedAt)}` : ""}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ) : null,
        )}
      </div>
    </div>
  );
}
